export default {
  menteeGoalGroupId(state) {
    return (state.package || {}).pillarid;
  },
};
